<script>
    import {push} from 'svelte-spa-router';
	import { fade } from 'svelte/transition';
	import Header from './Header.svelte';
    export let params = {}
	import { springIn } from "svelte-helpers/spring-transitions";
	import { tweened } from 'svelte/motion';
	import { cubicOut } from 'svelte/easing';
	import Modal, { bind } from 'svelte-simple-modal';
	import PopupMebot from './PopupMebot.svelte';
	import { writable } from 'svelte/store';
	//import { onMount } from 'svelte';

	import { loader } from './loader';
	let loading = writable(true);

	const modal = writable(null);

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    let dash_token = params.t
	if (dash_token != '1') {
		dash_token = getCookie("m_dash_token")
	}

	const battleness = tweened(0, {
		duration: 400,
		easing: cubicOut
	});

    const daily_power = tweened(0, {
		duration: 400,
		easing: cubicOut
	});

    daily_power.set(0);

    let mebot_id = params.id
    mebot_id = getCookie('m_id');

    let mebot_trips = [];
	let mebot_trips_tmp = [];
	let mebot_attr = [];
	let contenders = [];
	let contenders_tmp = [];

	let f1 = 0;
	let f2 = 0;
	let f3 = 0;

	function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	function set_section(name) {
        setCookie("section", name, 1)
    }

	set_section('battle');

	let result = null
    let mebot_img_url = null;
    let mebot_badges = '';
    let mebot = [];
	let liked = false;
	let show_close = true;
	let timeout_id;
	let tag = '';
	let city_n = '';
	let hab_n = '';
	let total_n = ''
	let steps_info = '';
	let mood = '';
	let uh_n = '';
	let social_link = null;
	let social_msg = null;
	let chall_id = 0;
	let chall_desc = '';
	let can_battle = 0;
	let title = '';
	let charge_title = '';
	let all_title = '';
	let page_size = 28;
	let daily_balance = '';
	let koed = '';

	let fetching = false;

	async function fetchMebotStats(mebot_id = 0) {

		await getBattleStage(0);

		const stat_type = 1;
		let res = await fetch('https://api.forever.today/?method=get_mebot_stat', {
			method: 'POST',
			body: JSON.stringify({
				dash_token,
                mebot_id,
                stat_type
            })
		})

        let json = await res.json()
        result = json
        //json.data.mebots.forEach((x, i) => console.log(x));

        mebot = json.data.mebot;
		if (mebot.badges.length > 0) {
			mebot_badges = mebot.badges[0].em
		}

		//console.log('got mebot id: ' + mebot.id)
        //mebot_i = i;
		liked = mebot.is_liked;
		tag = mebot.tag;
		city_n = mebot.city_n;
		hab_n = mebot.hab_n;
		total_n = mebot.total_n;
		steps_info = mebot.steps_info;
		mood = mebot.mood;
		uh_n = mebot.uh_n;
		chall_desc = mebot.chall_desc;
		chall_id = mebot.chall_id;
		can_battle = mebot.cb;

		social_link = mebot.social_link;
		social_msg = mebot.social_msg;

		mebot_img_url = mebot.mebot_img_url;

		await sleep(200);
        daily_power.set(mebot.dp/100);
		battleness.set(mebot.bas/100)
		//await sleep(100);
	}

    fetchMebotStats(mebot_id)

	let charged = Math.random() * 0.0025 + 0.0005;
	charged = 0.0008;
	const SPRING_IN = { stiffness: charged, damping: 0.0012 };
	const animateIn = (node) => {
		const { duration, tickToValue } = springIn(-4, 0, SPRING_IN);
		return {
			duration: 50000,
			css: (t) => `transform: translateY(${tickToValue(t)}px)`,
		};
	};

	function sleep(ms) {
		return new Promise((resolve) => setTimeout(resolve, ms ?? 200));
	}

    async function getBattleStage(offset = 0) {

		fetching = true;
		loading.update(n => fetching);

		const res = await fetch(
			"https://api.forever.today/?method=get_battle_stage",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id,
					f1: f1,
					f2: f2,
					f3: f3,
					offset
				}),
			}
		);

		const json = await res.json();
		let runners = json.data.trips;

		mebot_attr = json.data.attr;
		mebot_trips_tmp = [];
		let info_str = '';
		let land = null;

		for (const runner of runners) {

			land = null;
			if (runner.info != null) {
				info_str = runner.info

				if (runner.land_img != null) {
					land = runner.land_img
				}
			} else {
				info_str = runner.eff + '%'
			}
			mebot_trips_tmp.push({
				id: runner.m_id,
				img: runner.mebot_img_url,
				land_img: land,
				land_file_id: runner.land_file_id,
				sparkles: runner.sparkles,
				bas: runner.bas,
				prize: runner.prize,
				emp: runner.emp,
				eff: runner.eff,
				info: info_str,
				time_ago: runner.time_ago
			});
		}
		//mebot_trips = mebot_trips_tmp.slice(0, 14);

		if (offset == 0) {
			mebot_trips = mebot_trips_tmp;
		} else {
			//append
			mebot_trips = mebot_trips.concat(mebot_trips_tmp);
		}

		if (offset == 0) {
			let conts = json.data.conts;
			contenders_tmp = [];
			for (const runner of conts) {
				contenders_tmp.push({
					id: runner.m_id,
					img: runner.mebot_img_url,
					bas: runner.bas,
					prize: runner.prize,
					emp: runner.emp,
					eff: runner.eff,
					time_ago: runner.time_ago
				});
			}
			contenders = contenders_tmp;
		}

		title = json.data.title;
		all_title = json.data.all_title;
		charge_title = json.data.charge_title;
		page_size = json.data.page_size;
		daily_balance = json.data.d_b;
		koed = json.data.koed;

		fetching = false;
		loading.update(n => fetching);
	}

	async function filterMebots() {
		let v = '';

		f1 = document.getElementById("mtype").value;
		f2 = document.getElementById("mclass").value;
		f3 = document.getElementById("wattlvl").value;

	    //console.log(d);
		//getBattleStage();
	}

	let y;

	function doNothing() {
		console.log('do nothing');
		return;
	}

    function displayArtifactBlurb(blurb) {

		displayMebotMessage(`
		<center>
			<br>

			` + blurb + `

            <br>
		</center>`, 30000, 'Ok');
    }

	function displayMebotMessage(msg, delay, action_button = false, action = null) {
		let is_show_close = true
		clearTimeout(timeout_id);
		modal.set(null);
		show_close = is_show_close
		if (action != null) {
			modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button, on_action: action }));
		} else {
			modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button}));
		}
		timeout_id = setTimeout(function(){ modal.set(null); }, delay);
	}

    function numberWithCommas(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	const getX = () => {
        let myDiv = document.querySelector('.main1')
        myDiv.scrollTop = myDiv.scrollHeight;
        return myDiv.scrollHeight - myDiv.scrollTop;
    }

	let x = 800 // the value returned by getX() function
    let contentLength = 0; // number of items that load on the page initially

    const loadOnScroll = (elem) => {
		//console.log('scrollTop: ' + elem.scrollTop + ' scrollHeight: ' + elem.scrollHeight);
		if (elem.scrollTop >= (elem.scrollHeight - x) ) {

			if (fetching == false) {
				contentLength += page_size;
				getBattleStage(contentLength);
				console.log(contentLength)
			}
		}
	}

	//onMount(() => {
	//	console.log ( getX() );
	//});

</script>

<Header
    header_mebot_id = { mebot_id }
    header_dash_token = { dash_token }
/>

<!--<center>
    <div style="width: 300px; overflow: hidden">
        <iframe title="iframe" src="/ifeed.html" width="307" height="800"
            scrolling="yes" style="width: 307px; height: 800px; border:none;"
            allowtransparency="true">
            Mebots content            
        </iframe>
    </div>
</center>-->

<center>

	<div class="main1" on:scroll="{ () => loadOnScroll(document.querySelector('.main1')) }">
	<center>

	<table width=300px border=0 height=150px>
		<tr>
			<td width="50px" valign=top align=center>
				<table border=0 height=140px>
					<tr>
						<td height="30px" align=center>
						</td>
					</tr>
					<tr>
						<td align=center valign=middle>
							<div class="text-glow" style="white-space: nowrap; font-size: 20px;">
							</div>
						</td>
					</tr>
				</table>
			</td>
			<td width=150px align=center valign=bottom>
				{#if mebot_img_url}
				<div in:fade|local={{duration: 400}} style="user-select: none;" >
					<!--<div
						href="/#/move/{dash_token}/{m_id}"
						style="user-select: none;"
					>-->
						<div on:click={ displayArtifactBlurb( mebot.a_b ) }>
						<img style="user-select: none;"
							on:click={ displayArtifactBlurb( mebot.a_b ) }
							src={mebot_img_url}
							width="140px"
							alt="meebot"
							class="no_tap_zoom"
						/>
						</div>
					<!--</div>-->
				</div>
				{/if}
			</td>
			<td width="50px" valign=top>
				<table border=0 height=140px>
					<tr>
						<td height="30px" align=center>
							<div class="text-glow" style="white-space: nowrap; font-size: 20px;">
							<!--	⚔️ -->
							</div>
						</td>
					</tr>
					<tr>
						<td align=center valign=middle>
							<div class="text-glow" style="white-space: nowrap; font-size: 20px;">
							</div>
						</td>
					</tr>
				</table>
			</td>
		</tr>
	</table>
	<table width=300px border=0 height=150px>
		<tr height=20px>
			<td width=60px></td>
			<td colspan=2 align=center>

				{#if mebot_img_url}

				<div on:click={ displayArtifactBlurb( mebot.a_b ) }>
					{#if mebot.m_a != '- - - -' }
					<div class="text-electric" style="width: 100%; font-size: 14px; display: flex; align-items:center; justify-content: center;">
						{#each mebot.m_aa as artifact, i}
						<span style="display: inline;" class:info-pulsing-zombie-big={ ( artifact.em != '-' ) }> { artifact.em } </span> &nbsp;
						{/each}
					</div>
					{:else}
					<div class="text-electric-grey1" style="font-size: 14px;">
						{ mebot.m_a }
					</div>
					{/if}
				</div>

				<table width=160px height=65px border=0 valign=top on:click={ displayArtifactBlurb( mebot.a_b ) }>
							<tr>
								<td valign=bottom align=right> <span class="text-glow-green" style="font-size: 12px;"> {mebot.dp} </span> </td>
								<td width=130px valign=bottom>
									<div class="outer_daily_power" style="margin-top: 17px; margin-bottom: 6px;">
										<div class="progress_inner_daily_power" style="width: {$daily_power * 100}%; margin-top: 5px;" ></div>
									</div>
								</td>
								<td> &nbsp;&nbsp;&nbsp; </td>
							</tr>
							<tr height=18px>
								<td valign=bottom align=right> <span class="text-glow-blue" style="font-size: 12px;"> {mebot.bas} </span> </td>
								<td width=130px valign=bottom>
									<div class="outer_blue" style="margin-top: 0px; margin-bottom: 8px;">
										<span class="progress_inner_blue" style="width: {$battleness * 100}%; margin-top: 5px;"></span>
									</div>
								</td>
								<td> &nbsp;&nbsp;&nbsp; </td>
							</tr>
				</table>

				{#if daily_balance != 0 }
				<span class="text-electric text-glow" style="font-size: 12px;">
					{#if daily_balance > 0 }+{/if}{ numberWithCommas(daily_balance) }✨ {@html koed }
				</span>
				<br>
				{:else}
				<br>
				{/if}

				<br>
				{#if contenders_tmp.length > 0 }
				<div class="text-glow" style="font-size: 14px; margin-top: 30px; margin-bottom: 16px;" > &nbsp; {@html title} &nbsp;</div>
				{:else}
				{#if mebot.dp == 0 }
				<div class="text-glow" style="font-size: 14px; margin-top: 30px; margin-bottom: 16px;" > &nbsp; {@html charge_title} &nbsp;</div>
				{/if}
				<div class="text-glow" style="font-size: 14px; margin-top: 30px; margin-bottom: 16px;" > &nbsp; {@html all_title} &nbsp;</div>
				{/if}

				{/if}
			</td>
			<td width=60px></td>
		</tr>
	</table>

<center>
    <div class="snake_row">
        {#each contenders as mebot, i}
            <div class="flip-box mebot_small" >
                <div class="flip-box-inner">
                    <div class="flip-box-front card">
                        <div class="vertical-center" style="white-space: nowrap;">
							<div class="message question" data-card-id={i} style="margin-bottom: 16px;">
                                <a href="/#/battle/2/{mebot_id}/{mebot.id}">
                                <img src="{mebot.img}" width=105px alt="mebot"></a><br>
                                <div style="width: 135px; align-items: center;" >

									<table width=100px height=6px cellspacing=0 border=0 valign=top>
										<tr>
											<td valign=bottom align=right width=16px> <span class="text-glow-green" style="font-size: 10px;"> { mebot.emp } </span> </td>
											<td width=70px valign=middle>
												<div class="outer_daily_power" style="margin-top: 5px; margin-left: 2px; margin-bottom: 0px;">
													<div class="progress_inner_daily_power" style="width: { mebot.emp }%; margin-top: 5px;" ></div>
												</div>
											</td>
											<td width=14px> &nbsp; </td>
										</tr>
										<tr height=10px>
											<td valign=bottom align=right width=16px> <span class="text-glow-blue" style="font-size: 10px;"> {mebot.bas} </span> </td>
											<td width=70px valign=bottom align=center>
												<span class="text-glow-blue" style="font-size: 10px;">
												{#if mebot.prize > 0 }
												<span class="text-glow"> ✨{ numberWithCommas(mebot.prize) } </span>&nbsp;
												{/if}
												</span>
											</td>
											<td width=14px> &nbsp; </td>
										</tr>
									</table>

									<!-- <div class="text-glow-blue" style="font-size: 10px;">
										<div align="left" style="width: 54px; margin-bottom: 0px;">
										<div class="outer_daily_power" style="margin-top: 0px; margin-bottom: 8px;">
											<div class="progress_inner_daily_power" style="width: { mebot.emp }%; margin-top: 5px;" ></div>
										</div>
										</div>
										{ mebot.bas } <span class="text-glow">-</span> <span class="text-glow-green">{ mebot.emp }</span>
										{#if mebot.prize > 0 }
											<span class="text-glow"> ✨{ numberWithCommas(mebot.prize) } </span>&nbsp;
										{/if}
									</div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        {/each}
    </div>
</center>

{#if contenders_tmp.length > 0 }
<center>
<div class="text-glow" style="font-size: 14px; margin-top: 30px; margin-bottom: 16px;" > &nbsp; {@html all_title} &nbsp;</div>
</center>
{:else}
<br>
{/if}

<center>
    <div class="snake_row">
        {#each mebot_trips as mebot, i}
            <div class="flip-box mebot_small" >
                <div class="flip-box-inner">
                    <div class="flip-box-front card">
                        <div class="vertical-center" style="white-space: nowrap;">
							<div class="message question" data-card-id={i} style="margin-bottom: 16px;">
                                <a href="/#/battle/2/{mebot_id}/{mebot.id}">
                                <img src="{mebot.img}" width=78px alt="mebot"></a><br>
                                <div style="width: 95px; align-items: center;" >

									<table width=52px height=6px cellspacing=0 border=0 valign=top>
										<tr>
											<td valign=bottom align=center width=12px> <span class="text-glow-green" style="font-size: 10px;"> { mebot.emp } </span> </td>
											<td width=38px valign=middle>
												<div class="outer_daily_power" style="margin-top: 5px; margin-bottom: 0px;">
													<div class="progress_inner_daily_power" style="width: { mebot.emp }%; margin-top: 5px;" ></div>
												</div>
											</td>
											<td width=2px> </td>
										</tr>
										<tr height=10px>
											<td valign=bottom align=center width=12px> <span class="text-glow-blue" style="font-size: 10px;"> {mebot.bas} </span> </td>
											<td width=38px valign=bottom align=center>
												<span class="text-glow-blue" style="font-size: 10px;">
												{#if mebot.prize > 0 }
												<span class="text-glow"> ✨{ numberWithCommas(mebot.prize) } </span>&nbsp;
												{/if}
												</span>
											</td>
											<td width=2px> </td>
										</tr>
									</table>

<!--									<span class="text-glow-blue" style="font-size: 10px;">
										<div align="left" style="width: 54px; margin-bottom: 0px;">
										<div class="outer_daily_power" style="margin-top: 0px; margin-bottom: 8px;">
											<div class="progress_inner_daily_power" style="width: { mebot.emp }%; margin-top: 5px;" ></div>
										</div>
										</div>
										{ mebot.bas } 
										<span class="text-glow">-</span> <span class="text-glow-green">{ mebot.emp }</span>
									</div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        {/each}
    </div>
</center>

<div class="loader" use:loader={loading}>
</div>

    <br><br><br><br><br><br>

</center>

</div>

</center>

<Modal
        show={$modal}
		classWindowWrap="relative m-2 max-h-full"
        styleBg={{ backgroundColor: 'rgba(0, 0, 0, 0.2); opacity: .99;' }}
		styleWindow={{
			boxShadow: '0 20px 50px 0 rgba(0, 0, 0, 1)',
			backgroundColor: 'rgb(5, 20, 32, .96	); opacity: 1;'  }}
        closeButton={show_close}
		closeOnOuterClick={false}
		>
</Modal>

<style>

.text-blue {
		color: #00cafd;
}

.outer_blue {
	margin: 0px;
	background-color: transparent;
	border: 0px;
	box-shadow: 0 0 8px rgb(0, 179, 255), 0 0 20px rgba(130, 132, 132, 0.819);
	height: 2px;
	border-radius: 0px;
}

.progress_inner_blue {
	background-color: #00cafd;
	display: block;
	box-shadow: 0 0 8px rgb(0, 179, 255), 0 0 20px rgba(130, 132, 132, 0.819);
	height: 2px;
	border-radius: 0px;
}

.outer_daily_power{
		margin: 0px;
		background-color: transparent;
		border: 0px;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);
		height: 2px;
		border-radius: 0px;
}

.progress_inner_daily_power {
		background-color: #1bffe8ee;
		display: block;
		box-shadow: 0 0 8px rgb(255, 255, 0), 0 0 20px rgba(130, 132, 132, 0.819);
		height: 2px;
		border-radius: 0px;
}

.mebot-byline {
	font-size: 10px;
	white-space: nowrap;
}

.text-glow {
	text-shadow: 0 0 10px rgb(192 219 255 / 75%),
		0 0 32px rgb(65 120 255 / 88%);
	font-family: arial;
	color: white;
}

.text-glow-blue {
	text-shadow: 0 0 10px #00cafd,
		0 0 32px rgb(65 120 255 / 88%);
	font-family: arial;
	color: #00cafd;
}

.text-glow-green {
	text-shadow: 0 0 10px rgb(0, 255, 255), 0 0 32px rgba(0, 117, 117, 0.819);
	font-family: arial;
	color: #1bffe8ee;
}

.snake_row {
	display: flex;
	flex-wrap: wrap;
    width: 320px;
	justify-content: center;
	margin-bottom: 0px;
}

.filter {
	font-size: 12px;
    border-radius: 6px;
    border: 1px solid rgb(83, 83, 83);
    background-color: #016c8a;
	color: #1bffe8ee;
}

.main1 {
    border-radius: 20px;
    background-color: transparent;
    background-color: transparent;
    height: 700px;
    width: 370px;
    overflow-x: hidden;
    overflow-y: auto;
    text-align: left;
    padding: 0px;
    overscroll-behavior: auto;
    border: none;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}

.main1::-webkit-scrollbar {
  display: none;
}

.main {
		background-color: rgba(0, 0, 0, 0.465);
		overflow-x: auto;
		overflow-y: auto;
		background-image: url("/img/nyc_bg_sm.jpeg");
		background-position: center; /* Center the image */
		background-repeat: no-repeat; /* Do not repeat the image */
		background-size: cover; /* Resize the background image to cover the entire container */
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		touch-action: manipulation;
		overflow: auto;
		-webkit-appearance: none;
		overscroll-behavior: auto;
    height: 4000px;  
    margin-top: 50px;
}

.vitals-small {
	font-size: 12px;
}

.vitals-mid {
	font-size: 14px;
}

.text-glow-blueish {
	text-shadow: 0 0 10px rgb(192 219 255 / 75%),
		0 0 32px rgb(65 120 255 / 88%);
	font-family: arial;
	color: hsl(185, 40%, 70%);
}

.text-glow-gray {
	text-shadow: 0 0 10px rgb(192 219 255 / 75%),
		0 0 32px rgb(65 120 255 / 88%);
	font-family: arial;
	color: #ffffff77;
}

.land_sm {
	border-radius: 10px;
}

</style>